function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFilterList = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 216 162",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M47.045,91.699C47.445,82.683 44.284,73.871 38.245,67.165C25.813,53.335 4.581,29.761 4.581,29.761C-0.131,24.528 -1.323,17.012 1.541,10.578C4.405,4.145 10.787,-0 17.83,0L129.562,0C136.604,-0 142.987,4.145 145.85,10.578C148.714,17.012 147.523,24.528 142.81,29.761C142.81,29.761 121.555,53.361 109.113,67.176C103.031,73.931 99.872,82.82 100.328,91.898C100.357,112.789 100.363,148.164 100.363,148.164C100.363,153.308 97.458,158.012 92.858,160.316C88.258,162.621 82.752,162.13 78.631,159.049L49.963,137.611C48.116,136.23 47.028,134.058 47.028,131.752C47.028,131.752 47.034,107.936 47.045,91.699Z",
    style: {
      fill: "rgb(204,204,204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.042,13.692C215.042,10.061 213.6,6.578 211.032,4.01C208.464,1.443 204.982,0 201.35,-0C193.376,0 183.355,0 175.38,0C171.749,0 168.267,1.443 165.699,4.01C163.131,6.578 161.688,10.061 161.689,13.692C161.689,13.695 161.689,13.697 161.689,13.7C161.688,17.331 163.131,20.814 165.699,23.381C168.267,25.949 171.749,27.392 175.38,27.392C183.355,27.392 193.376,27.392 201.35,27.392C204.982,27.392 208.464,25.949 211.032,23.381C213.6,20.814 215.042,17.331 215.042,13.7C215.042,13.697 215.042,13.695 215.042,13.692Z",
    style: {
      fill: "rgb(204,204,204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.042,81.043C215.042,77.411 213.6,73.929 211.032,71.361C208.464,68.793 204.982,67.351 201.35,67.351C186.565,67.351 163.15,67.351 148.365,67.351C144.734,67.351 141.251,68.793 138.683,71.361C136.116,73.929 134.673,77.411 134.673,81.043C134.673,81.045 134.673,81.048 134.673,81.05C134.673,84.682 136.116,88.164 138.683,90.732C141.251,93.3 144.734,94.742 148.365,94.742C163.15,94.742 186.565,94.742 201.35,94.742C204.982,94.742 208.464,93.3 211.032,90.732C213.6,88.164 215.042,84.682 215.042,81.05C215.042,81.048 215.042,81.045 215.042,81.043Z",
    style: {
      fill: "rgb(204,204,204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.042,148.056C215.042,144.425 213.6,140.942 211.032,138.374C208.464,135.807 204.982,134.364 201.35,134.364C186.565,134.364 163.15,134.364 148.365,134.364C144.734,134.364 141.251,135.807 138.683,138.374C136.116,140.942 134.673,144.425 134.673,148.056C134.673,148.059 134.673,148.061 134.673,148.064C134.673,151.695 136.116,155.178 138.683,157.746C141.251,160.313 144.734,161.756 148.365,161.756C163.15,161.756 186.565,161.756 201.35,161.756C204.982,161.756 208.464,160.313 211.032,157.746C213.6,155.178 215.042,151.695 215.042,148.064C215.042,148.061 215.042,148.059 215.042,148.056Z",
    style: {
      fill: "rgb(204,204,204)"
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFilterList);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/filter-list.f0839a3fb177f3e0676de0d662f8f870.svg";